import { useI18n } from '@platform/i18n';
import { ConstructionIcon } from 'lucide-react';
import { PageBody, PageHeader } from '../composites/page';
import { EmptyState } from '../composites/states';
import type { BreadcrumbItem } from '../navigation';

/** Page for registered but not yet built routes (`status: 'planned'` in the registry). */
export function PlaceholderPage({ title, breadcrumb }: { title: string; breadcrumb?: readonly BreadcrumbItem[] }) {
  const { t } = useI18n();
  return (
    <>
      <PageHeader title={title} breadcrumb={breadcrumb} />
      <PageBody>
        <EmptyState icon={ConstructionIcon} title={t('common.comingSoon')} description={t('common.comingSoonDescription')} />
      </PageBody>
    </>
  );
}
